export var Permission;
(function (Permission) {
    Permission[Permission["HandleInteraction"] = 1] = "HandleInteraction";
    Permission[Permission["ViewSearch"] = 2] = "ViewSearch";
    Permission[Permission["ViewTemplate"] = 3] = "ViewTemplate";
    Permission[Permission["EditUser"] = 4] = "EditUser";
    Permission[Permission["EditUserSkill"] = 5] = "EditUserSkill";
    Permission[Permission["EditUserLanguage"] = 6] = "EditUserLanguage";
    Permission[Permission["EditAgentState"] = 7] = "EditAgentState";
    Permission[Permission["EditWidget"] = 8] = "EditWidget";
    Permission[Permission["EditChatBan"] = 9] = "EditChatBan";
    Permission[Permission["ToggleWidget"] = 10] = "ToggleWidget";
    Permission[Permission["EditLanguage"] = 11] = "EditLanguage";
    Permission[Permission["EditEmailRoutingRule"] = 12] = "EditEmailRoutingRule";
    Permission[Permission["EditDepartment"] = 13] = "EditDepartment";
    Permission[Permission["EditSkill"] = 14] = "EditSkill";
    Permission[Permission["EditTextLocalisation"] = 15] = "EditTextLocalisation";
    Permission[Permission["EditSystemSetting"] = 16] = "EditSystemSetting";
    Permission[Permission["EditLogic"] = 17] = "EditLogic";
    Permission[Permission["ViewReporting"] = 18] = "ViewReporting";
    Permission[Permission["EditTemplate"] = 19] = "EditTemplate";
    Permission[Permission["EditTheme"] = 20] = "EditTheme";
    Permission[Permission["EditForm"] = 21] = "EditForm";
    Permission[Permission["ViewEmailAssignment"] = 22] = "ViewEmailAssignment";
    Permission[Permission["EditBrand"] = 23] = "EditBrand";
    Permission[Permission["EditUserBasic"] = 24] = "EditUserBasic";
    Permission[Permission["RedactContent"] = 25] = "RedactContent";
    Permission[Permission["DeleteAttachment"] = 26] = "DeleteAttachment";
    Permission[Permission["EditFormField"] = 27] = "EditFormField";
    Permission[Permission["AssignInteraction"] = 28] = "AssignInteraction";
    Permission[Permission["EditRole"] = 29] = "EditRole";
})(Permission || (Permission = {}));
//# sourceMappingURL=permissions.js.map